import { Component, OnInit } from '@angular/core';
import { BaseComponent } from '@premotec/pmt-essentials';
import { environment } from '../../../../environments/environment';
import { UserAuthorizationService } from '../../../security/services/user-authorization.service';

@Component({
    selector: 'app-side-navbar',
    templateUrl: './side-navbar.component.html',
    styleUrls: ['./side-navbar.component.scss']
})
export class SideNavbarComponent extends BaseComponent implements OnInit {

    protected isDevOrTestEnvironment: boolean = environment.production == false;
    protected isAdmin: boolean = false;

    protected toolsOnlineDeskUrl = environment.onlineDeskUrl;
    protected toolsWebplannerUrl = environment.webPlannerUrl;

    protected adminHangfireUrl = environment.hangfireUrl;
    protected adminToolMailUrl = environment.testMailsUrl;

    constructor(private authService: UserAuthorizationService) {
        super();
    }

    public ngOnInit(): void {
        this.authService.isLoggedIn().then((x) => {
            if (x) {
                let user = this.authService.getUser();
                this.isAdmin = user.isAdmin()
            }
        });
    }
}